/**
 * @@deprecated Use IconButton from da-ds instead
 */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import SimpleTooltip from '../../../tooltips/dsPreset/SimpleTooltip';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './IconButton.scss';
const IconButton = (_param)=>{
    var { className, tooltipClassName, tooltipText, tooltipOffset, disabled, noHoverEffect, noActiveEffect = noHoverEffect, onClick, children, biData } = _param, restProps = _object_without_properties(_param, [
        "className",
        "tooltipClassName",
        "tooltipText",
        "tooltipOffset",
        "disabled",
        "noHoverEffect",
        "noActiveEffect",
        "onClick",
        "children",
        "biData"
    ]);
    const isMobile = useContext(MobileContext);
    const showHoverEffect = !(noHoverEffect !== null && noHoverEffect !== void 0 ? noHoverEffect : isMobile);
    const showActiveEffect = !(noHoverEffect !== null && noHoverEffect !== void 0 ? noHoverEffect : isMobile);
    return /*#__PURE__*/ React.createElement(BiButton, _object_spread({
        onClick: !disabled ? onClick : undefined,
        className: classnames(s['root'], disabled && s['disabled'], showHoverEffect && s['with-hover-effect'], showActiveEffect && s['with-active-effect'], className),
        biData: biData,
        disabled: disabled
    }, restProps), tooltipText ? /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        portalClassName: tooltipClassName,
        text: tooltipText,
        offsetModifier: tooltipOffset
    }, children) : children);
};
IconButton.displayName = 'IconButton';
export default IconButton;
